/**
 * Extend the Window interface to include the `dataLayer` property.
 * @typedef {typeof globalThis & { dataLayer?: Array<(...args: any[]) => void | any[]> }} CustomWindow
 */

function gtag() {
  const win = /** @type {CustomWindow} */ (window)
  if (typeof window !== 'undefined' && typeof win.dataLayer === 'object') {
    // @ts-expect-error
    win.dataLayer.push(arguments)
  }
}

/**
 * Send a Google Tag Manager (gtag) event.
 * @param {string} config The config id.
 * @param {object} event The event object.
 */

export async function gtagsConversion(config, event) {
  gtag('js', new Date())
  gtag('config', config)
  gtag('event', 'conversion', event)
}
